<template>
  <div class="select_lang_modal">
    <!--モーダルダイアログ表示リンク-->
    <a v-if="0 < this.language.length" v-on:click="launchModalDialog()" role="button">
      <i class="fas fa-globe"></i>
      {{ selectedLanguages }}
    </a>

    <!--モーダルダイアログ本体-->
    <modal
      v-model="isShowModal"
      class="modal fade"
      id="modal1"
      ref="modal"
      size="lg"
      :footer="false">
      <div slot="title">
        <h3 class="modal-title">
          <!-- 言語を選択してください -->
          <LabelFunMessage fcontId="0" msgkey="176" />
        </h3>
      </div>
      <div>
        <!-- <div class="scrolldown"><span>scroll</span></div> -->
        <ul class="LanguageList row">
          <li
            :class="['col-xs-12','col-sm-3', 
              {selected: isSelectedLg2(item.lg2)}
            ]" 
            :key="index" 
            :value="item.lg2" 
            v-for="(item, index) in this.sortedLanguages">
            <a v-on:click="changeLanguage(item.lg2)">
              {{ item.displayName }}
            </a>
          </li>
        </ul>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Modal } from "uiv";
import LabelFunMessage from "../components/LabelFunMessage";

export default {
  name: 'SelectLangModal',
  data: function() {
    return {
    }
  },
  components: {
    Modal,LabelFunMessage,
  },
  computed: {
    ...mapState("languages", ['language']),
    isShowModal: {
      get () {
        // QTAS#53773対応 言語選択モーダルが消えたらbodyの属性を強制的に変更する
        if (this.$store.state.showLangModal == false) {
          const body_element = document.getElementsByTagName('body')
          body_element[0].classList.remove('modal-open');
          body_element[0].style.paddingRight = null
        }
        return this.$store.state.showLangModal
      },
      set (value) {
        this.$store.commit('setShowLangModal', value)
      }
    },
    sortedLanguages: function () {
      let languages = this.language
      languages.slice().sort((a, b) =>{
        if (a.englishName > b.englishName) {
          return 1
        } else {
          return -1
        }
      })
      return languages
    },
    selectedLanguages: function () {
      let languages = this.language
      const language = languages.find(language => language.lg2 === this.$store.state.lg2)
      return language.displayName
    }
  },
  methods: {
    launchModalDialog: function () {
      this.$gtag.event("tap_button", {
        "custom_parameter1": "language_open"
      })
      this.isShowModal = true;
    },
    isSelectedLg2: function (lg2) {
      return this.$store.state.lg2 === lg2
    },
    changeLanguage: function (afterLg2) {
      this.$log.debug('isSelectedLg2', afterLg2);
      this.$gtag.event("tap_button", {
        "custom_parameter1": "language",
        "custom_parameter2": afterLg2
      })
      let beforeLg2 = this.$store.state.lg2
      this.$store.dispatch('messages/fetchMessages', { lg2: afterLg2, locale: this.$store.state.locale })
      this.$store.dispatch('createplusMessages/fetchMessages', { lg2: afterLg2, locale: this.$store.state.locale });
      this.$store.commit('changeLanguage', afterLg2)
      this.$router.push({ 
        path: this.$route.path.replace(`/${beforeLg2}/`,`/${afterLg2}/`),
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
      })
      this.isShowModal = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-content {
  background-color: white;
}
/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
  .modal-title {
    font-size: 18px;
  }
}
</style>